import { Routes } from '@angular/router';
import { RegisterPageComponent } from './components/register-page/register-page.component';
import { MagementPageComponent } from './components/magement-page/magement-page.component';

export const routes: Routes = [
    { path: 'register', component: RegisterPageComponent},
    { path: 'manage', component: MagementPageComponent},
    { path: '**', redirectTo: '/register', pathMatch: 'full' },
];
